(function ($) {
    var prefix = "bp-";

    // These are container minimum widths.  Do not confuse them with viewport breakpoints.
    var sizes = [
        { name: "xs", width: 0 },
        { name: "sm", width: 380 },
        { name: "md", width: 480 },
        { name: "lg", width: 720 },
        { name: "xl", width: 1024 },
    ];

    function applySizeClass(element) {
        var size = calculateSize(element);
        element.removeClass(size.remove.join(" ")).addClass(size.add.join(" "));
        element.data("breakpoint", size.current);
        return size;
    }

    function calculateSize(element) {
        var width = parseInt(element.css("width"), 10);
        var obj = { add: [], remove: [] };
        var maxSize = sizes[0].name;

        // Calculate classes to add/remove and keep track of maximum breakpoint that's applicable
        sizes.forEach(function (size) {
            var within = width >= size.width;
            obj[within ? "add" : "remove"].push(prefix + size.name);
            if (within) {
                maxSize = size.name;
            }
        });

        // Add the 'bp-max-XX' class to denote the current breakpoint
        sizes.forEach(function (size) {
            obj[size.name === maxSize ? "add" : "remove"].push(prefix + "max-" + size.name);
        });

        obj.current = maxSize;

        return obj;
    }

    function trackBPinBody() {
        var wW = window.innerWidth;
        var bpAttr = "data-bp";

        for (var i = 0; i < sizes.length; i++) {
            var nextBP = i === sizes.length - 1 ? sizes.length - 1 : i + 1;
            if (wW < sizes[nextBP].width) {
                $("body").attr(bpAttr, sizes[i].name);
                break;
            } else if (wW >= sizes[i].width) {
                $("body").attr(bpAttr, sizes[i].name);
            }
        }
    }

    function onResize(selector) {
        selector = selector || ".breakpoints";
        $(selector).each(function () {
            applySizeClass($(this));
        });
        trackBPinBody();
        $.publish("xom.breakpoints");
    }

    // Ensure all placeholders have the "breakpoints" class
    $(function () {
        $(".row").children("[class*=col]").addClass("breakpoints");
        onResize(".breakpoints");
    });

    $(window).off("load resize").on("load", function () {
        onResize(".breakpoints");
    });
    
    $(window).on("resize", function () {
        window._debounce(onResize(".breakpoints"), 250);
    });

    $("body").on("click", ".nav-link", function () {
        setTimeout(function () {
            onResize(".breakpoints");
        }, 200);
    });
})(window.jQuery);